<template>
  <div>
    <span class="badge badge-warning" v-if="chargeType == 'GeneralSurcharge'">General Surcharge</span>
    <span class="badge badge-info" v-else-if="chargeType == 'FuelSurcharge'">Fuel Surcharge</span>
    <span class="badge badge-primary" v-else-if="chargeType == 'FreightCharge'">Freight Charge</span>
    <span class="badge badge-secondary" v-else>Other Surcharge</span>
  </div>
</template>

<script>
export default {
  props: {
    chargeType: {
      required: true
    }
  }
}
</script>

<style>

</style>
